module.exports = __webpack_public_path__ + "b915f68ad32c3781a386b0aec8bf1b43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/4.jpg
// module id = 287
// module chunks = 0